import { GtmTracker } from '@wbk/analytics';

export const gtmTracker = new GtmTracker({
  gtmIds: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER?.split(',') || [],
  log: process.env.NEXT_PUBLIC_ENV !== 'production',
});
